import {
  getActiveDynamicPage,
  getCategoryNavMetadata,
} from "./dynamicPageService";

const FIVE_MINUTES = 5 * 60 * 1000;

// Query definitions shared by the pages that read them and the route loaders
// that prefetch them, so both land on one cache entry.
export const dynamicPageQuery = (category, name) => ({
  queryKey: ["dynamicPage", category, name],
  queryFn: () => getActiveDynamicPage(category, name),
  staleTime: FIVE_MINUTES,
});

export const dynamicPageNavQuery = (category) => ({
  queryKey: ["dynamicPageNav", category],
  queryFn: () => getCategoryNavMetadata(category),
  staleTime: FIVE_MINUTES,
});
